"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductGridFeaturedItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productGridItem = _interopRequireDefault(require("./product-grid-item"));
var _image = require("@site/pattern-library-core/image");
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * Render ProductGridFeaturedItem
 *
 * @param {Object} props React props
 * @param {String} props.id Product Grid Item id
 * @param {String} props._name Product Grid Item tracking name
 * @param {Object} props.image Featured item image
 * @param {String} props.text Text label
 * @param {String} props.link Link url
 * @param {Boolean} props.hoverEffect Hover State Condition
 * @param {Boolean} props.openInNewWindow - set target to _blank if true
 * @param {Object} props.style required for Linaria Styling Overrides
 * @param {String} props.className required for Linaria Styling Overrides
 * @returns {React.ReactElement} ProductGridItem component
 * @public
 */
function ProductGridFeaturedItem({
  id,
  _name,
  image = {},
  title,
  text: featuredText,
  link,
  tagLabel,
  labelDesign,
  hoverEffect = false,
  openInNewWindow = false,
  style,
  className
}) {
  const target = openInNewWindow ? {
    target: '_blank'
  } : {};
  const {
    url,
    altText,
    height,
    width
  } = image;
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "product-grid-featured-item",
    className: className,
    style: style,
    href: link,
    "data-hover-active": hoverEffect
  }, target, _patternLibraryUtils.tracking.create(_name, true, true)), url && /*#__PURE__*/_react.default.createElement("img", {
    src: url,
    alt: altText,
    height: height,
    width: width
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "featured-content"
  }, tagLabel && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "featured-tag"
  }, /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tagLabel,
    design: labelDesign
  })), title && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 1,
    "data-cy": "featured-title",
    text: title
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "featured-text"
  }, featuredText)));
}
ProductGridFeaturedItem.propTypes = {
  image: _propTypes.default.shape(_image.imgPropShape),
  ..._productGridItem.default.propTypes
};